/**
 * クロス設定登録画面 クロス商品設定削除(リクエストパラメータ)用クラス
 *
 * @export CrossGoodsDelete
 * @class CrossGoodsDelete
 */
export class CrossGoodsDelete {
  /** 受注コード */
  public orderCode = String('');
  /** クロスコード */
  public crossCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
}
